module.exports = __webpack_public_path__ + "img/18.30606f6b.jpg";